import { db } from '@/database/client';

export async function exportDatabaseBackup(): Promise<string> {
  const backupData: Record<string, unknown> = {};
  for (const table of db.tables) {
    backupData[table.name] = await table.toArray();
  }
  return JSON.stringify(backupData);
}

export async function importDatabaseBackup(jsonString: string): Promise<void> {
  const parsed = JSON.parse(jsonString) as Record<string, unknown>;
  await db.transaction('rw', db.tables, async () => {
    for (const table of db.tables) {
      if (parsed[table.name]) {
        await table.clear();
        await table.bulkAdd(parsed[table.name] as Array<unknown>);
      }
    }
  });
}
